import { KEYCLOAK_URL } from "../../constants/environment";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LOGOUT_URL } from "../../constants/urls";
import { ILogoutConfiguration } from "./interfaces/ILogoutConfiguration";

const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: KEYCLOAK_URL,
  }),
  endpoints: (builder) => ({
    logout: builder.mutation<boolean, ILogoutConfiguration>({
      query: (payload) => {
        const logoutParams = new URLSearchParams();
        Object.entries(payload).forEach(([key, value]) => {
          logoutParams.append(key, value);
        });
        return {
          url: `${LOGOUT_URL}`,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: logoutParams.toString(),
        };
      },
    }),
  }),
});

export const { useLogoutMutation } = api;

export default api;
